// extracted by mini-css-extract-plugin
export default {"cardContent":"ResumenMetricas_cardContent__Qgy50","icon":"ResumenMetricas_icon__cHde8","resumen-general":"ResumenMetricas_resumen-general__U2SA8"};